import { Pipe, PipeTransform } from '@angular/core';
import { getResourceDisplayName, projectEnv } from 'utils';

/**
 * Searching in Autocomplete with pre-populated values.
 * WARNING: Do not use for use cases where the list of values is dynamically loaded from the Web API.
 */
@Pipe({
  name: 'autocompleteSearch',
  standalone: true,
})
export class AutocompleteSearchPipe implements PipeTransform {
  transform(availableFilters: string[], searchedValue: string): any {
    if (searchedValue && searchedValue !== '') {
      const matchedFilters = availableFilters.filter((availableFilter) => {
        return getResourceDisplayName(
          availableFilter,
          projectEnv.get('projectName')
        )
          .toLowerCase()
          .includes(searchedValue.toString().toLowerCase());
      });
      return matchedFilters;
    } else {
      return availableFilters;
    }
  }
}
